import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VList,_vm._l((_vm.zones),function(zone){return _c(VListItem,{key:zone.id},[_c(VListItemAvatar,[_c(VIcon,[_vm._v("map")])],1),_c(VListItemContent,[_c(VListItemTitle,[_vm._v(_vm._s(zone.name))]),_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.$t('maps.zone.zone')))])],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }